import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';
import componentStyles from './sic-nonprofit-contact.css.lit';

/**
 * The nonprofit contact / map component
 * @slot map
 * @slot form
 */

@customElement('sic-nonprofit-contact')
export class SicNonprofitContact extends OutlineElement {
  private slots = new SlotsController(this);
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`<div class="container">
      ${this.slots.conditionalSlot('form', false)}
      ${this.slots.conditionalSlot('map', false)}
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-nonprofit-contact': SicNonprofitContact;
  }
}
